<script>
import ActionWithTooltip from "@/components/ActionWithTooltip.vue";
import HeaderElement from "@/components/article/HeaderElement.vue";
import AudioButton from "@/components/AudioButton.vue";
import TouchOrMouseElement from "@/components/TouchOrMouseElement.vue";
import lang from "@/directives/lang";

export default {
  name: "ArticleContentHeader",
  components: {
    ActionWithTooltip,
    AudioButton,
    HeaderElement,
    TouchOrMouseElement
  },
  directives: {
    lang
  },
  props: {
    word: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      required: true
    }
  },
  methods: {
    trackPronunciationClick() {
      MatomoHelper.sendEvent(
        MatomoEventCategory.Results,
        MatomoEventAction.ClickPronunciation,
        "Pronunciation on headword"
      );
    }
  }
};
</script>

<template>
  <div class="article-content__header article-header justify-content-between">
    <div class="article-header__content">
      <div class="d-inline-block">
        <h5 class="article-header__word">
          <sup v-if="word.hnr">{{ word.hnr }}</sup>
          {{ word.lemma }}
          <template v-if="word.or && word.alternative">
            <span class="article-header__word-alternative-separator mr-2">
              {{ word.or }}
            </span>
            <span v-html="word.alternative"></span>
          </template>
        </h5>
        <span
          v-if="direction === 'enda' && word.flexion"
          class="article-header__inflections"
          v-html="word.flexion"
        ></span>
        <HeaderElement
          v-if="word.wordClass"
          v-lang:da
          :content="word.wordClass"
          :wrapped="false"
          class="article-header__element article-header__element--light"
        />
      </div>
    </div>
    <div class="article-header__controls">
      <TouchOrMouseElement v-if="word.pronunciationId" class="d-inline-flex">
        <template #mouse>
          <ActionWithTooltip hide-on-click class="article-header__btn">
            <template #element>
              <AudioButton
                :audio-url="word.pronunciationId"
                :artia-label="$t('article.pronunciation.label')"
                @click="trackPronunciationClick()"
              />
            </template>
            <template #actionInitial>{{ $t("article.pronunciation.label") }}</template>
          </ActionWithTooltip>
        </template>
        <template #touch>
          <AudioButton
            :audio-url="word.pronunciationId"
            class="article-header__btn"
            :artia-label="$t('article.pronunciation.label')"
            @click="trackPronunciationClick()"
          />
        </template>
      </TouchOrMouseElement>
    </div>
  </div>
</template>
